import {formatPriceNew} from "src/utils/formatPrice";
import {_does} from "src/components/Planner/planner/uMath";
import {ts} from "src/utils/translate"

import {clearStringOfQuoteIDs} from "src/utils/controllerAdapterForOfferPage";

export const getNewQuoteRows = (rows, showServices = true) => {
  let result = [];
  const rowsGrouped = {};

  try {
    result = showServices ? rows.devices.concat(rows.services) : rows.devices;
      
    result.filter((row) =>
        typeof row.product_name === "string" && row.product_name.trim().length
    );
  } catch (err) {
    console.error(err);
  }

  result = Object.values(result.reduce((acc, curr) => {

    const { product_name, article_number, manufacturer_name, quantity, ...rest } = curr;
    let key = JSON.stringify(curr);;
  
    if (!result) {
      return;
    }
  
    if (curr.quantity) {
      curr.quantity = parseInt(curr.quantity);
    }
  
    if (curr.quantity) {
      const priceKeys = Object.keys(rest).filter(k => k.startsWith('price_')).sort();
      const pricesSuffix = priceKeys.length > 0 ? `_prices_${priceKeys.map(k => rest[k]).join('_')}` : '';

      if (product_name && article_number) {
        key = `article_${article_number}_name_${product_name}${pricesSuffix}`;
      }

      else if (product_name && manufacturer_name && !article_number) {
        key = `name_${product_name}_manufacturer_${manufacturer_name}${pricesSuffix}`;
      }

      else if (product_name && priceKeys.length > 0) {
        key = `name_${product_name}${pricesSuffix}`;
      }
    }
  
    if (acc[key]) {
      acc[key].quantity += curr.quantity;
    } else {
      acc[key] = { ...curr };
    }
    return acc;
  
  }, {}));

  result.forEach((row) => {
    const rowClone = Object.assign({}, row);
    if (rowClone.__entityType === "roomtable" && rowClone.product_id) {
      rowClone.custom_item_id = null;
    }

    const uniqueKeys = [
      "product_id",
      "custom_item_id",
      "user_custom_items_id",
      "manufacturer_name",
      "custom_section_item_id",
    ];
    const rowKey = uniqueKeys.map((key) => rowClone[key] || "-").join("_");

    if (!(rowKey in rowsGrouped)) {
      rowClone.quantity = Number(rowClone.quantity);
      rowClone.rowKey = rowKey;
      rowsGrouped[rowKey] = Object.assign({}, rowClone);
    } else {
      rowsGrouped[rowKey].quantity += Number(rowClone.quantity);
    }
  });

  let minusElements = Object.values(rowsGrouped).filter((item) => {
    return item.quantity < 0;
  });

  result = Object.values(rowsGrouped).filter((row) => row.quantity > 0);

  minusElements.map((minusElementItem) => {
    const rowIndex = result.findIndex((rowIndexElement) => {
      return rowIndexElement.product_id == minusElementItem.product_id;
    });

    if (rowIndex && result[rowIndex]) {
      try {
        result[rowIndex].quantity += minusElementItem.quantity;
      } catch (e) {
        console.log(e);
      }
    }
  });

  result = Object.values(rowsGrouped).filter((row) => row.quantity > 0);

  return result;
};

const getNewColumns = (columns, btnPressedStates, currency) => {
  const currencyKey = `price_${currency}`;

  let result = columns.filter(
    (col) =>
      typeof col.name === "string" &&
      _does([
        "product_name",
        "quantity",
        `price_${currency}`,
        "total_price",
      ]).contain(col.name)
  );

  if (+btnPressedStates["q-ppi"] < 2) {
    result = result.filter((col) => col.name.indexOf("price") === -1);
  }

  result.forEach((col) => {
    // default case
    col.render = (self, full) => {
      return self || "";
    };

    // unique cases
    // current currency
    if (col.data === currencyKey) {
      col.width = 150;
      col.render = (self, full) => {
        return formatPriceNew(self, currency);
      };
      col.numeric = true;
    } else if (col.data === "total_price") {
      col.width = 150;
      col.render = (self, full) => {
        return formatPriceNew(full[currencyKey] * full.quantity, currency);
      };
      col.numeric = true;
    } else if (col.data === "product_name") {
      col.render = (self, full) => {
        return clearStringOfQuoteIDs(self);
      };
    } else if (col.data === "quantity") {
      col.width = 35;
      col.numeric = true;
    }
  });

  result.splice(1, 0, {
    data: "design",
    name: "design",
    title: "",
    width: 200,
    render: (self, full) => {
      let colorName = "";
      let manuName = "";
      let designName = "";

      if (full.color_name) {
        colorName = full.color_name;
      }

      if (full.design) {
        designName = full.design;
      }

      if (full.manufacturer_name) {
        manuName = full.manufacturer_name;
      }

      if (manuName === "Cable") {
        manuName = "";
      }

      if (manuName) {
        manuName =
          "<li> <b>" + ts('manufacturer_name', 'manufacturer_name') + ":</b> " + manuName + "</li>";
      }

      if (colorName) {
        colorName =
          "<li> <b>" +
          ts('color_name_without_design', 'color_name_without_design') +
          ":</b> " +
          colorName +
          "</li>";
      }

      if (designName) {
        designName = "<li> <b>" + ts('design', 'design') + ":</b> " + designName + "</li>";
      }

      return (
        '<ul style="margin-bottom: 0px;">' +
        manuName +
        designName +
        colorName +
        "</ul>"
      );
    },
  });

  return result;
};
